export default defineNuxtRouteMiddleware(() => {
	const store = useUserStore()
	const localePath = useLocalePath()
	if (!store.state.user) return

	return navigateTo(localePath('/'))
})
